import React, { useCallback, useRef } from 'react'

import { useRouter } from 'next/navigation'

import { NewsCard } from 'Components/Blocks'
import { Loader, Row } from 'Components/UI'
import { NewsItem } from 'Types/emajinAPI'

import { BLOG_POST } from 'Constants/Paths'

import { usePaginatedFetch } from 'Hooks'

import APIService from 'Services/API'

import { Container } from './styles'

const ITEM_PER_VIEW = 3

function LatestNewsSectionGallery() {
  const ref = useRef(null)
  const router = useRouter()

  const fetchPage = useCallback(async () => {
    const res = await APIService.getNews({
      limit: ITEM_PER_VIEW,
      offset: 0,
    })
    return res.news ?? []
  }, [])

  const {
    items: news,
    loading,
    error,
  } = usePaginatedFetch<NewsItem>({
    limit: ITEM_PER_VIEW,
    fetchPage,
  })

  const handleReadMoreClick = useCallback(
    (data: NewsItem) => {
      sessionStorage.setItem('blogPost', JSON.stringify(data))
      router.push(BLOG_POST(data.id))
    },
    [router],
  )

  if (error) return null

  return (
    <Container
      alignItems={['center', 'center', 'unset']}
      flexDirection={['column', 'column', 'row']}
      ref={ref}
    >
      {loading ? (
        <Row alignCenter fullWidth height={624} justifyCenter>
          <Loader size={32} />
        </Row>
      ) : (
        news.map(item => (
          <NewsCard
            data={item}
            key={item.id}
            onReadMore={() => handleReadMoreClick(item)}
          />
        ))
      )}
    </Container>
  )
}

export default LatestNewsSectionGallery
